/**
 * Stable import path for applying an `EditorPayload` into session.
 *
 * Implementation lives on `useEditorSessionStore` (TEA `ApplyPayload` Msg).
 * Call sites (workspace Cmds, cloud, shell) keep importing from here so they
 * do not need a Pinia instance at module load.
 */
import type { EditorPayload } from "../lib/tauri/core";
import { useEditorSessionStore } from "./useEditorSessionStore";

export type ApplyPayloadOpts = {
  keepDoc?: boolean;
  /** Same-project scene/note navigation: skip Harper + full word recount (#107). */
  navigationOnly?: boolean;
};

export function applyPayload(
  payload: EditorPayload,
  opts?: ApplyPayloadOpts,
): void {
  useEditorSessionStore().applyPayload(payload, opts);
}
